import { FooterButtonContainer } from '~/shared/forms/buttons/FooterButtonContainer';
import { CancelButton } from '~/shared/forms/buttons/CancelButton';
import { FormSubmitButton } from '~/shared/forms/buttons/FormSubmitButton';
import { type FormProps, Form, FormChildren } from '~/shared/forms/Form';
import { ContentSizeWrapper } from '~/shared/ContentSizeWrapper';
import { PageSection, type PageSectionProps } from '~/shared/section/PageSection';

export function LibraryForm({ children, ...props }: FormProps & Omit<PageSectionProps, 'children'>) {
	return (
		<ContentSizeWrapper>
			<Form {...props}>
				{formHelpers => {
					return (
						<PageSection {...props}>
							{formHelpers.displayErrorElement && formHelpers.errorElement}
							<div className="bg-white p-6">
								<div className="mb-8 flex flex-col gap-6">
									<FormChildren>{children}</FormChildren>
								</div>
								<FooterButtonContainer className="border-t border-gray-200 pt-6">
									<CancelButton goBackOnCancel />
									<FormSubmitButton />
								</FooterButtonContainer>
							</div>
						</PageSection>
					);
				}}
			</Form>
		</ContentSizeWrapper>
	);
}
